import { render, staticRenderFns } from "./DeviceComp.vue?vue&type=template&id=ffcd92d6&scoped=true"
import script from "./DeviceComp.vue?vue&type=script&lang=js"
export * from "./DeviceComp.vue?vue&type=script&lang=js"
import style0 from "./DeviceComp.vue?vue&type=style&index=0&id=ffcd92d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffcd92d6",
  null
  
)

/* custom blocks */
import block0 from "./DeviceComp.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports